(function() {
  'use strict';

  function initTabs(section) {
    const tabs = Array.from(section.querySelectorAll('[data-ep-tab]'));
    const panels = Array.from(section.querySelectorAll('[data-ep-panel]'));
    if (!tabs.length || !panels.length) return;

    function activateTab(index) {
      tabs.forEach((tab, i) => {
        const isActive = i === index;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      panels.forEach((panel, i) => {
        const isActive = i === index;
        panel.classList.toggle('is-active', isActive);
        panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
    }

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activateTab(index));
      tab.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          event.preventDefault();
          const next = (index + 1) % tabs.length;
          tabs[next].focus();
          activateTab(next);
        }
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          event.preventDefault();
          const prev = (index - 1 + tabs.length) % tabs.length;
          tabs[prev].focus();
          activateTab(prev);
        }
      });
    });

    activateTab(0);
  }

  function init() {
    document.querySelectorAll('.ep-configurator-steps').forEach(initTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
